export const DELETE_RESOURCE = 'DELETE_RESOURCE';
export const FETCH_RESOURCES = 'FETCH_RESOURCES';
export const FETCH_RESOURCES_SUCCESS = 'FETCH_RESOURCES_SUCCESS';
export const EDIT_RESOURCE = 'EDIT_RESOURCE';
export const CREATE_RESOURCE = 'CREATE_RESOURCE';
export const ACTION_ERROR = 'ACTION_ERROR';
